export default "/_next/static/images/product-at-9a475ed6b01b902b7289d5c8049f37ac.svg";